"use client";

import {
  Accessibility,
  Ban,
  CarFront,
  DollarSign,
  FileText,
  FileWarning,
  FileX,
  Flag,
  Gauge,
  Gavel,
  Hash,
  Lock,
  ShieldX,
  Siren,
  Skull,
  Truck,
  Wine,
  Wrench,
} from "lucide-react";
import clsx from "clsx";
import { AnimatedList } from "./ui/animated-list";
import "./criminal-violations-list.css";

const violations = [
  { name: "Driving While Under the Influence", severity: "high", icon: Wine },
  { name: "License Suspended or Revoked Driving", severity: "high", icon: Ban },
  {
    name: "Leaving Scene of Accident (Hit & Run)",
    severity: "high",
    icon: CarFront,
  },
  { name: "Driving in a Reckless, Wild Manner", severity: "high", icon: Gauge },
  {
    name: "Causing Death by Vehicle (Manslaughter)",
    severity: "high",
    icon: Skull,
  },
  { name: "Illegal Street Speed Racing Contest", severity: "high", icon: Flag },
  { name: "Fleeing Police in a Motor Vehicle", severity: "high", icon: Siren },
  {
    name: "Operating Vehicle with No License",
    severity: "medium",
    icon: FileX,
  },
  {
    name: "Using Forged DMV Documents to Defraud",
    severity: "high",
    icon: FileWarning,
  },
  { name: "Stealing or Taking a Motor Vehicle", severity: "high", icon: Lock },
  {
    name: "Falsifying Vehicle Registration Info",
    severity: "medium",
    icon: FileText,
  },
  {
    name: "Rolling Back or Hiding the Odometer",
    severity: "medium",
    icon: Gauge,
  },
  {
    name: "Faking Car Crash for Insurance Scam",
    severity: "high",
    icon: DollarSign,
  },
  {
    name: "No Proof of Valid Auto Insurance",
    severity: "medium",
    icon: ShieldX,
  },
  { name: "Car Mods or Tint Violating the Law", severity: "low", icon: Wrench },
  {
    name: "Unqualified Commercial Driver Use",
    severity: "medium",
    icon: Truck,
  },
  {
    name: "Abusing Disabled Placard Privileges",
    severity: "medium",
    icon: Accessibility,
  },
  { name: "Removing or Altering a Car's VIN", severity: "high", icon: Hash },
  {
    name: "Ignoring a Court Order or Summons",
    severity: "medium",
    icon: Gavel,
  },
];

const colorOrder = [
  "#ef4444", // red
  "#a855f7", // purple
  "#eab308", // yellow
  "#f97316", // orange
  "#ec4899", // pink
  "#f59e0b", // amber
];

const getColorByIndex = (index) => {
  return colorOrder[index % colorOrder.length];
};

const ViolationItem = ({ name, severity, icon: Icon, index }) => {
  const bgColor = getColorByIndex(index);
  return (
    <figure className="r2-criminal-violations__card">
      <div className="r2-criminal-violations__row">
        <div
          className="r2-criminal-violations__icon"
          style={{
            backgroundColor: bgColor,
          }}
        >
          <Icon className="r2-criminal-violations__icon-svg" />
        </div>
        <div className="r2-criminal-violations__text">
          <figcaption className="r2-criminal-violations__title">
            <span className="r2-criminal-violations__title-text">{name}</span>
          </figcaption>
          <p className="r2-criminal-violations__severity">
            {severity === "high"
              ? "High Risk"
              : severity === "medium"
              ? "Medium Risk"
              : "Low Risk"}
          </p>
        </div>
      </div>
    </figure>
  );
};

export function CriminalViolationsList({ className }) {
  return (
    <div className={clsx("r2-criminal-violations", className)}>
      <AnimatedList delay={1000}>
        {violations.map((item, idx) => (
          <ViolationItem {...item} index={idx} key={idx} />
        ))}
      </AnimatedList>
    </div>
  );
}
